import { Module } from '@nestjs/common';
import { MonitoringsService } from './monitorings.service';
import { MonitoringsController } from './monitorings.controller';
import { MonitoringsEntity, UsersEntity } from '@crm/dto';
import { TypeOrmModule } from '@nestjs/typeorm';
import { GuardsModule } from '../guards/guards.module';
import { SupabaseModule } from '../supabase/supabase.module';

@Module({
  controllers: [MonitoringsController],
  providers: [MonitoringsService],
  imports: [TypeOrmModule.forFeature([MonitoringsEntity, UsersEntity]), GuardsModule, SupabaseModule],
})
export class MonitoringsModule {}
